import React from "react";
import { Button, Tooltip, Box, Typography, Chip } from "@mui/material";
import { AutoAwesome } from "@mui/icons-material";

// Not wired to anything yet — a preview of an upcoming premium feature
// (upload a purchase invoice, AI extracts the order/item details and
// creates the shipment automatically) so customers and admins can see it
// coming and know roughly what it'll cost. Shared between CustomerShipments
// and AdminShipments rather than duplicated, since the copy/pricing must
// stay identical in both places.
const AnalyzeWithAiButton = () => (
  <Tooltip
    arrow
    enterTouchDelay={0}
    title={
      // MUI's default Tooltip bubble is a dark surface — Typography's own
      // default color (near-black, meant for light backgrounds) is nearly
      // invisible on it, so both lines need an explicit light color here.
      <Box sx={{ p: 0.5, maxWidth: 260 }}>
        <Typography variant="body2" fontWeight={700} sx={{ mb: 0.5, color: "common.white" }}>
          Analyze with AI — Coming Soon
        </Typography>
        <Typography variant="caption" sx={{ display: "block", color: "rgba(255,255,255,0.85)" }}>
          Upload your purchase invoice and AI will read it and create the shipment
          for you automatically — no manual entry needed. Will be included with
          Premium accounts, Starting from around $10–15/month.
        </Typography>
      </Box>
    }
  >
    <span>
      <Button variant="outlined" startIcon={<AutoAwesome />} disabled>
        Analyze with AI
        <Chip
          label="Soon"
          size="small"
          color="primary"
          sx={{ ml: 1, height: 18, fontSize: 10, fontWeight: 700 }}
        />
      </Button>
    </span>
  </Tooltip>
);

export default AnalyzeWithAiButton;
